
import React, { useState } from "react";
import { useSelector } from "react-redux";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";
import { Link } from "react-router-dom";
import SearchBoxModal from "../component/SearchBoxModal";
import Select from "react-select";
import Moment from "react-moment";


export default function DanhSachTanTuyen() {
  const { user } = useSelector((state) => state.auth);
  const [params, setParam] = useState('usertype=1');
  const [fullname, setFullname] = useState('');
  const [code, setCode] = useState('');
  const [part_id, setPart_Id] = useState();
  const [authorId, setAuthorId] = useState("");
  const [company_id, setCompany_Id] = useState();
  const [chucvu_id, setChucvu_Id] = useState('all');
  const [email, setEmail] = useState("");
  const [userStatus, setUserStatus] = useState([]);
  const [tantuyenStatus, setTantuyenStatus] = useState([]);
  const [filterShow, setFilterShow] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault();
    let _param = 'usertype=1'
    if (part_id) _param += "&part_id=" + part_id
    if (company_id) _param += "&company_id=" + company_id
    if (chucvu_id > 0) _param += "&chucvu_id=" + chucvu_id
    if (fullname !== '') _param += "&fullname=" + fullname
    if (code !== '') _param += "&code=" + code
    if (email !== '') _param += "&email=" + email
    if (authorId && authorId !== '') _param += "&author_id=" + authorId
    if (userStatus && userStatus != '') _param += "&status=" + userStatus.map((item) => item.value).join(";");
    if (tantuyenStatus && tantuyenStatus != '') _param += "&status_tt=" + tantuyenStatus.map((item) => item.value).join(";");

    // console.log(_param);
    setParam(_param);
  };
  let columns = [
    { name: "id", label: "ID", options: { filter: false, sort: true } },
    {
      name: "fullname", label: "Thông tin",
      options: {
        filter: false, sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <div className="mw-sm-300">
            Họ tên: <strong>{value}</strong><br />
            Mã nhân viên: <strong>{tableMeta.code}</strong><br />
            Chức vụ: <strong>{tableMeta.chucvu}</strong><br />
            Phòng ban: <strong>{tableMeta.part_title}</strong><br />
            Công ty: <strong>{tableMeta.company}</strong><br />
          </div>
        },
      }
    },
    {
      name: "mobile", label: "Liên hệ",
      options: {
        filter: false, sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return <div style={{ minWidth: 200 }}>
            <i className="fas fa-phone-alt"></i> {value}<br />
            <i className="far fa-envelope-open"></i> {tableMeta.email}<br />
          </div>
        },
      }
    },
    {
      name: "status", label: "Trạng thái làm việc",
      options: {
        filter: false, sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          let text_status = '';
          if (value == 0) {
            let time = new Date(tableMeta.ngaynghiviec);
            text_status = <><strong className="text-danger">Đã nghỉ</strong><br />{tableMeta.ngaynghiviec ? <Moment format="DD/MM/YYYY">{time}</Moment> : ''}</>
          }
          if (value == 1) text_status = <strong className="text-success">Chính thức</strong>
          if (value == 2) text_status = <strong className="text-primary">Thử việc</strong>
          if (value == 3) text_status = <strong className="text-warning">Chưa nhận việc</strong>
          if (value == 4) text_status = <strong className="text-info">Thực tập sinh</strong>
          if (value == 5) text_status = <strong className="text-primary">Cộng tác viên</strong>
          if (value == 6) text_status = <strong className="text-primary">Khoán việc</strong>

          return text_status
        },
      }
    },
    {
      name: "status_tt", label: "Trạng thái tân tuyển",
      options: {
        filter: false, sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          let text_status = '';
          if (value == 0) {
            text_status = <><strong className="text-danger">Chưa tham gia</strong><br /></>
          }
          if (value == 1) text_status = <strong className="text-success">Đã tham gia</strong>
          return text_status
        },
      }
    },
    { name: "datecreate", label: "Ngày tạo" },
    { name: "author_name", label: "Người tạo" },

  ];

  const handleMultiChange = (selected) => {
    setUserStatus(selected);
  };

  return (<AkkhorLayout idrole="tan-tuyen">
    <div className="breadcrumbs-area">
      <ul>
        <li>
          <Link to="/">Trang chủ</Link>
        </li>
        <li>
          Danh sách tân tuyển
        </li>
      </ul>
    </div>

    <div className="card card-filter mb-3">
      <div className="card-header">
        <div className="d-flex" onClick={() => setFilterShow(!filterShow)}>
          <div className="mr-auto">
            <h3 className="title">Tìm kiếm</h3>
          </div>
          <button className="btn btn-sm btn-defaul"><span className={!filterShow ? "fas fa-angle-down" : "fas fa-angle-up"}></span></button>
        </div>
      </div>
      <div className={filterShow ? "card-body" : 'hidden-filter'}>
        <form className="new-added-form" method="get" >
          <div className="row">
            <div className="col-sm-3 col-12 form-group">
              <label>Tên nhân viên </label>
              <input type="text" placeholder="Tìm theo tên" value={fullname} onChange={(e) => setFullname(e.target.value)} className="form-control height32" autoComplete="off" />
            </div>
            <div className="col-sm-3 col-12 form-group">
              <label>Mã nhân viên </label>
              <input type="text" placeholder="Tìm theo mã nhân viên" value={code} onChange={(e) => setCode(e.target.value)} className="form-control height32" autoComplete="off" />
            </div>
            <div className="col-sm-3 col-12 form-group">
              <label>Email</label>
              <input type="text" placeholder="Tìm theo email" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control height32" autoComplete="off" />
            </div>
           
            <div className="col-sm-3 col-12 form-group">
              <label>Công ty </label>
              <SearchBoxModal apiname={"company"} placeholder="Chọn Công ty" colvalue={'id'} colname={'title'} name='company_id'
                onChange={(e) => {
                  setCompany_Id(e)
                }}></SearchBoxModal>
            </div>
            <div className="col-sm-3 col-12 form-group">
              <label>Phòng ban </label>
              <SearchBoxModal apiname={"parts"} placeholder="Chọn phòng ban" colvalue={'id'} colname={'title'} name='part_id'
                onChange={(e) => {
                  setPart_Id(e)
                }}></SearchBoxModal>
            </div>

            <div className="col-sm-3 col-12 form-group">
              <label>Chức vụ </label>
              <SearchBoxModal apiname={"chucvu"} placeholder="Chọn chức vụ" colvalue={'id'} colname={'title'} name='chucvu_id'
                onChange={(e) => {
                  setChucvu_Id(e)
                }}></SearchBoxModal>
            </div>

            <div className="col-sm-3 col-12 form-group">
              <label>Người tạo </label>
              <SearchBoxModal apiname={"users"} placeholder="Chọn người tạo" colvalue={'id'} colname={'fullname'} name='author_id'
                onChange={(e) => {
                  setAuthorId(e)
                }}></SearchBoxModal>
            </div>
            <div className="col-12 col-sm-3 form-group">
              <label>Trạng thái làm việc: </label>
              <Select
                name="filters"
                placeholder="Filters"
                value={userStatus}
                options={[
                  { value: "", label: "Tất cả" },
                  { value: "6", label: "Khoán việc" },
                  { value: "5", label: "Cộng tác viên" },
                  { value: "4", label: "Thực tập sinh" },
                  { value: "3", label: "Chưa nhận việc" },
                  { value: "2", label: "Đang thử việc" },
                  { value: "1", label: "Đang chính thức" },
                  { value: "0", label: "Đã nghỉ" },
                ]}
                onChange={handleMultiChange}
                isMulti
              />
            </div>
            <div className="col-12 col-sm-3 form-group">
              <label>Trạng thái tân tuyển: </label>
              <Select
                name="filters"
                placeholder="Filters"
                value={tantuyenStatus}
                options={[
                  { value: "1", label: "Đã tham gia" },
                  { value: "0", label: "Chưa tham gia" },
                ]}
                onChange={(e) =>setTantuyenStatus(e)}
              />
            </div>

            <div className="col-12 ">
              <button type="submit" onClick={handleSubmit} className="btn-fill-sm btn-gradient-yellow btn-hover-bluedark">Lọc</button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <SRList name="users_tdd" idrole="tan-tuyen" params={params} title="Tài khoản" defaultLimit={20} serverSide={true} columns={columns}>
    </SRList>
  </AkkhorLayout>);
}
